import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-cierant-swiper',
  templateUrl: './cierant-swiper.component.html',
  styleUrls: ['./cierant-swiper.component.scss']
})
export class CierantSwiperComponent implements OnInit {
  @Input() hideArrows: boolean;
  @Input() swiperConfig: SwiperOptions;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/cierant-swiper/cierant-swiper.component.ts